import { Link, useRouteError } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function RouteErrorBoundary() {
  useRouteError();
  const { t } = useTranslation();

  return (
    <main className="app-main">
      <h1 className="page-heading">{t("route.errorTitle")}</h1>
      <p className="page-intro">{t("route.errorDescription")}</p>
      <Link to="/">{t("route.returnHome")}</Link>
    </main>
  );
}

export function RouteLoading() {
  const { t } = useTranslation();

  return (
    <p className="route-loading" role="status">
      {t("route.loading")}
    </p>
  );
}
